import { Skeleton } from '@picsart/design-system/components/Skeleton';
import useStyles from './styles';

const TopBannerSkeleton = () => {
  const styles = useStyles();
  return (
    <div className={styles.root} data-testid="font-title-skeleton">
      <Skeleton className={styles.skeletonTitle} />
      <Skeleton className={styles.skeletonDescription} />
    </div>
  );
};

export default TopBannerSkeleton;
